import type { LookInsidePage } from './lookInsidePages'

/** Sample pages from Volume 4: Create & Perform, in display order. Caption doubles as alt text. */
export const volumePreviewPages: LookInsidePage[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/vXZd9xogKjpwQvW9QphkVA/01-portada-vol4.webp',
    label: 'Vol. 4 · Cover',
    caption: 'Dance Class Ready Volume 4 cover: kids dancing on taped stage marks',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/oJ2novvGvMjTRCKBX2QLK8/02-combo-card-shape-the-stage.webp',
    label: 'Vol. 4 · Combo Card',
    caption: 'Combo card with formation diagrams in Starter, Core and Stretch levels',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/vfKk5Pddp5AacbGw86nMYK/03-formation-library.webp',
    label: 'Vol. 4 · Formation Library',
    caption: 'Formation library with 12 stage formations on a grid',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/hWjjSYLUnBoCjgGyVtDwrM/04-build-a-move-cards.webp',
    label: 'Vol. 4 · Build-a-Move',
    caption: 'Printable Build-a-Move cards for kids to create their own steps',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/krvnuhB9Eg8vrQRXVthfjn/05-always-in-the-back-vs-rotating.webp',
    label: 'Vol. 4 · Rotating Lines',
    caption: 'Comparison: same kids always in the back vs rotating lines',
  },
]
